import styled, { css } from 'styled-components';

import { Link } from '@zillow/zrs-comet';
import { mediaMixin, Text } from '@zillow/constellation';

export const StyledTextLink = styled(Link)`
    && {
        font-size: 12px;
        font-weight: 400;

        ${mediaMixin('lg', css`
            font-size: 14px;
            font-weight: 600;
        `)}

        /* 1024 */
        ${mediaMixin('xl', css`
            font-size: 16px;
        `)}
    }
`;

export const StyledText = styled(Text)`
    && {
        font-size: 12px;
        font-weight: 400;

        ${mediaMixin('lg', css`
            font-size: 14px;
            font-weight: 600;
        `)}

        /* 1024 */
        ${mediaMixin('xl', css`
            font-size: 16px;
        `)}
    }
`;
